import { render, staticRenderFns } from "./CardPlans.vue?vue&type=template&id=b810cecc&"
import script from "./CardPlans.vue?vue&type=script&lang=js&"
export * from "./CardPlans.vue?vue&type=script&lang=js&"
import style0 from "./CardPlans.vue?vue&type=style&index=0&id=b810cecc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports